export const gameVariants = [
	"web",
	"mobile",
	"empire_machine",
	"es_premium",
	"es_premium_xl",
	"es_machine",
	"es3_machine",
	"es3_sequence_machine",
	"esj_esn_machine",
	"prince_machine",
	"vip_machine",
	"vr",
	"web_4k"
];